import {
  Dashboard,
  NavigationElement,
  PublishedDashboard,
  PublishedNavigationElement,
} from "@/lib/api";

import routes from "./navigation.routes";

export const getDashboardById = (
  dashboards: Dashboard[] | undefined,
  id: string | undefined,
) => {
  if (!id) return undefined;

  return dashboards?.find((dashboard) => dashboard.id === id);
};

export const getDashboardBySlug = (
  dashboards: PublishedDashboard[] | undefined,
  slug?: string,
) => {
  if (!slug) return undefined;

  return dashboards?.find((dashboard) => dashboard.slug === slug);
};

export const getNavigationElementBySlug = (
  navigationElements: PublishedNavigationElement[],
  pageSlug: string | undefined,
  subPageSlug: string | undefined,
) => {
  if (!pageSlug || !Array.isArray(navigationElements)) return undefined;

  // Recursive function to search for a page by slug
  const findPageBySlug = (
    elements: PublishedNavigationElement[],
    targetSlug?: string,
    subTargetSlug?: string,
  ): PublishedNavigationElement | undefined => {
    for (const element of elements) {
      if (element.slug === targetSlug) {
        if (!subTargetSlug) {
          return element;
        }

        const childPage = (element.children as PublishedNavigationElement[]).find(
          (page) => page.slug === subTargetSlug,
        );
        if (childPage) {
          return childPage;
        }
      }
    }

    return undefined;
  };

  // Start the search with the top-level navigation elements
  return findPageBySlug(navigationElements, pageSlug, subPageSlug);
};
export const getFirstNavigationElementUrl = (
  navigationElements: PublishedNavigationElement[] | undefined,
): string | undefined => {
  return navigationElements?.[0].slug;
};

/**
 * Returns the slug path from dashboard root to the page with the given page_id,
 * for building dashboard view URLs from CMS context. Uses flat list and parent_id.
 */
export const getSlugPathForPageId = (
  navigationElements: NavigationElement[],
  pageId: string | undefined,
): string[] | undefined => {
  if (!pageId || !navigationElements?.length) return undefined;
  const element = navigationElements.find((el) => el.page_id === pageId);
  if (!element?.slug) return undefined;
  const path: NavigationElement[] = [element];
  let current: NavigationElement | undefined = element;
  while (current?.parent_id) {
    current = navigationElements.find((el) => el.id === current?.parent_id);
    if (!current) break;
    path.unshift(current);
  }
  return path.map((p) => p.slug).filter((s): s is string => !!s);
};

export const getLoginRouteWithState = (state: string) => {
  return `${routes.auth.login}?state=${state}`;
};
